import(/* webpackMode: "eager" */ "/app/src/app/[username]/page.tsx");
